import {resolveHelpURL} from '../../../../utils/url'

export const UNIT = 8
export const whatsNewHref: string = resolveHelpURL("?What's+New+in+TeamCity")
export const aboutSakuraUIHref: string = resolveHelpURL('teamcity-sakura-ui.html')
